module.exports = [
	{
		"value": "",
		"label": "Onbekend"
	},
	{
		"value": "single",
		"label": "Alleenstaand"
	},
	{
		"value": "married",
		"label": "Gehuwd"
	},
	{
		"value": "cohabiting",
		"label": "Samenwonend"
	},
	{
		"value": "unmarriedpartners",
		"label": "Ongehuwdmetpartner"
	},
	{
		"value": "divorced",
		"label": "Gescheiden"
	},
	{
		"value": "widowed",
		"label": "Weduwenaar/Weduwe"
	}
];


//////////////////
// WEBPACK FOOTER
// ./js/modules/person/constants/PersonMaritalStatusOptions.json
// module id = 35
// module chunks = 0